import { render, staticRenderFns } from "./DiscoverProducts.vue?vue&type=template&id=1fab6d19&"
import script from "./DiscoverProducts.vue?vue&type=script&lang=js&"
export * from "./DiscoverProducts.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports